import React from "react";
import { Link } from "react-router-dom";

const AdvertisingAgent = (props) => {
  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h5 className="title_text text-dark">
              Turn Everyday Shopping into Real Income
            </h5>
            <p className="text-dark opacity-75">
              Becoming a Topcoin UK Advertising Agent is simple, exciting, and rewarding. 
              You’ll earn your own Topcoin, completely separate from the customer’s Topcoin 
              or Bonus, every time someone you introduce shops and earns Topcoin.
            </p>
            <p className="text-dark opacity-75">
              Wherever they shop, from any participating business, you’ll automatically 
              receive the same amount of Topcoin they earn. It’s our way of saying thank you 
              for helping us grow and share the Topcoin UK movement.
            </p>
            <p className="text-dark opacity-75">
              The Topcoin you earn as an Advertising Agent is totally separate from your 
              personal Topcoin and Bonus — this is an independent reward system made just 
              for advertising agents.
            </p>

            <h5 className="title_text text-dark">The More You Share, The More You Earn</h5>
            <p className="text-dark opacity-75">
              Each person you refer becomes part of your Advertising Block Chain. As your 
              block chain grows, so do your rewards — every new customer adds more Topcoin 
              to your account.
            </p>

            <p className="text-dark opacity-75">
              <strong>Example:</strong><br />
              For every <strong>20,000 Topcoin</strong> you earn from your block chain, 
              you’ll receive <strong>£100</strong> in your Advertising Agent Wallet — 
              and it keeps growing from there!
            </p>

            <h5 className="title_text text-dark">Why Join Topcoin UK as an Advertising Agent?</h5>
            <ul>
              <li className="text-dark opacity-75">Earn unlimited Topcoin just by sharing and referring.</li>
              <li className="text-dark opacity-75">Build your own income network that grows automatically.</li>
              <li className="text-dark opacity-75">No limits, no risks — just rewards.</li>
              <li className="text-dark opacity-75">Completely free to join.</li>
            </ul>

            <p className="text-dark opacity-75">
              It’s very easy to become an Advertising Agent — just follow our simple 
              step-by-step guide and start sharing Topcoin UK with others today!
            </p>

            <h5 className="title_text text-dark">Topcoin UK — Where Everyone Can Earn</h5>
            <p className="text-dark opacity-75">
              Join the movement that turns everyday shopping into real value.<br />
            </p>
            <h5 className="title_text text-dark">Topcoin UK — Where Your Voice Builds Value.</h5>
             <p className="text-dark opacity-75">No limits. No risks. Just rewards.</p> 

            <h5 className="title_text text-dark">For Young Agents (Ages 16 and Above)</h5>
            <p className="text-dark opacity-75">
              Anyone aged 16 and above can become a Topcoin UK Advertising Agent and start earning Topcoin today!<br />
              “Topcoin UK allows users aged 16 and up to participate with parental or guardian consent. 
              Under 18s cannot withdraw cash without guardian approval.”</p>

            {/* NEW CARD SECTION */}
            <div className="d-flex justify-content-center my-5">
              <div className="card shadow-sm border-0"style={{ maxWidth: "1000px", width: "100%" }}>
                <div className="card-body text-center">
                  <h5 className="mt-4 mb-4" data-aos="fade-up" data-aos-duration="800">
                    What Happens After You Join?
                  </h5>

                  <p className="card-text mb-4 ps-3 pe-3 opacity-75" data-aos="fade-up" data-aos-duration="800">
                    Once you join as a customer, you can start inviting others. 
                    After you have referred new customers, you can apply to become an 
                    Advertising Agent and unlock rewards as your network grows.
                  </p>

                  <ul className="opacity-75 ms-3 ps-5 pe-5 text-start" style={{ display: "inline-block" }} data-aos="fade-up" data-aos-duration="800">
                    <li className="mb-3">
                      <strong>Step 1 – Join as a Customer: </strong>  
                      Click the button to create your account instantly.
                    </li>
                    <li className="mb-3">
                      <strong>Step 2 – Invite New Customers: </strong>  
                      After joining, share your referral link and invite family and friends to join Topcoin UK.
                    </li>
                    <li className="mb-3">
                      <strong>Step 3 – Request for Advertising Agent: </strong>  
                      Once you have invited customers, submit your request to become an Advertising Agent.
                    </li>
                    <li className="mb-3">
                      <strong>Step 4 – Start Earning: </strong>  
                      Earn rewards every time your invited customers join and shop.
                    </li>
                  </ul>

                  <div className="mt-3 mb-5">
                    <Link className="ico_creative_btn" to="/sign_up">
                      <span className="btn_wrapper px-5 py-0">
                        <span className="btn_label">Join Now</span>
                        <span className="btn_icon_right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            fill="currentColor"
                          >
                            <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                          </svg>
                        </span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvertisingAgent;
